export enum ReportType {
    ERROR = "error"
}
